export function getBrowser(userAgent: string | null) {
  const match = userAgent?.match(/firefox|chrome|safari|instagram|msie/i);

  if (!match) return 'unknown';

  const [browser] = match;

  return browser!.toLowerCase();
}

export function isAppleMobileDevice(userAgent: string | null) {
  if (!userAgent) return false;

  return /iPhone|iPad/i.test(userAgent);
}

export function isInAppBrowser(userAgent: string = '') {
  return /instagram|fban|fbav|twitter/i.test(userAgent);
}
